export const LOCAL_STORAGE_KEYS = {
  FLAT_TABLE_COLUMNS: 'FLAT_TABLE_COLUMNS',
};

type KeysType = keyof typeof LOCAL_STORAGE_KEYS;

export const getLocalStorageKey = (
  key: typeof LOCAL_STORAGE_KEYS[KeysType]
): string => `PLB_${LOCAL_STORAGE_KEYS[key]}`;
